import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {ArticleComponent} from "./article/article.component";
import {AboutUsComponent} from "./about-us/about-us.component";
import {CategoryComponent} from "./category/category.component";
import {CostGuideComponent} from "./cost-guide/cost-guide-page/cost-guide.component";
import {HomeComponent} from "./home/home.component";
import {CostGuideListComponent} from "./cost-guide/cost-guide-list/cost-guide-list.component";
import {CostOfLivingComponent} from "./cost-of-living/cost-of-living.component";
import {SuccessPageComponent} from "./lead-form/successpage/successpage.component";
import {QuestionnaireFormComponent} from "./lead-form/questionnaire-form/questionnaire-form.component";

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  { path: 'cost-guides',
    component: CostGuideListComponent,
    pathMatch: 'full'
  },
  { path: 'costs/:seoId',
    component: CostGuideComponent,
    pathMatch: 'full'
  },
  { path: 'articles/:seoId',
    component: ArticleComponent,
    pathMatch: 'full'
  },
  { path: 'sources/:seoId',
    component: ArticleComponent,
    pathMatch: 'full'
  },
  { path: 'privacy-policy.html',
    component: ArticleComponent,
    pathMatch: 'full'
  },
  { path: 'terms-of-use.html',
    component: ArticleComponent,
    pathMatch: 'full'
  },
  { path: 'economy',
    component: CategoryComponent,
    pathMatch: 'full'
  },
  { path: 'personal-finance',
    component: CategoryComponent,
    pathMatch: 'full'
  },
  { path: 'remodeling-form/:formId',
    component: QuestionnaireFormComponent,
    pathMatch: 'full'
  },
  { path: 'remodeling-form-success',
    component: SuccessPageComponent,
    pathMatch: 'full'
  },
  { path: 'insurance-form/:formId',
    component: QuestionnaireFormComponent,
    pathMatch: 'full'
  },
  { path: 'insurance-form-success',
    component: SuccessPageComponent,
    pathMatch: 'full'
  },
  { path: 'business',
    component: CategoryComponent,
    pathMatch: 'full'
  },
  { path: 'real-estate',
    component: CategoryComponent,
    pathMatch: 'full'
  },
  { path: 'about-us.html',
    component: AboutUsComponent,
    pathMatch: 'full'
  },
  { path: 'cost-of-living/:state/:city',
    component: CostOfLivingComponent,
    pathMatch: 'full'
  },
  { path: 'cost-of-living/:state/:city/',
    component: CostOfLivingComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

export const routedComponents = [
  CostGuideComponent,
  CostGuideListComponent,
  HomeComponent,
  ArticleComponent,
  CategoryComponent,
  AboutUsComponent,
  QuestionnaireFormComponent,
  CostOfLivingComponent,
  SuccessPageComponent
];



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts